import { render, staticRenderFns } from "./mobile-nav-body.vue?vue&type=template&id=8d16df48&scoped=true&"
import script from "./mobile-nav-body.vue?vue&type=script&lang=js&"
export * from "./mobile-nav-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d16df48",
  null
  
)

export default component.exports